import React from 'react';
import Icon from 'antd/es/icon';
import Button from 'antd/es/button';
import message from 'antd/es/message';
import Input from 'antd/es/input';
import Form from 'antd/es/form';
import {client} from '../../apollo/apolloClient';
import {Add_User, CHECK_USER_NAME} from '../../apollo/schema';

class WrappedNavbarSignup extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
  };

  handleSignupSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        delete values['confirm'];
        values['email'] = values['email'].toLowerCase();
        values['userName'] = values['userName'].toLowerCase();
        client.mutate({
          mutation: Add_User,
          variables: {input: values},
        }).then(res => {
          if (!res.hasOwnProperty('errors')) {
            message.success('Please Confirm Your email to continue');
            window.location.reload();
          } else {
            message.error('Something went wrong. Please try again');
          }

        });
      }

    });

  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({confirmDirty: this.state.confirmDirty || !!value});
  };

  validateExistingUser = (rule, value, callback) => {
    if (value && value.length > 5) {
      const userName = value.toLowerCase();
      client.query({
        query: CHECK_USER_NAME,
        variables: {userName},
      }).then(result => {
        if (result.data && result.data.checkUserName) {
          callback('Sorry, this username is already taken');
        } else callback();
      });
    } else callback();
  };

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else callback();
  };

  render() {
    const {form: {getFieldDecorator}, handleFormDisplay, inPage} = this.props;
    return (
        <Form onSubmit={this.handleSignupSubmit}>
          <Form.Item className="text-center">
            <img
                src={'https://assets-new.medcampus.io/assets/images/medcampus-icon.jpg'}
                width={150}
                alt={'logo'}
                style={{margin: 'auto'}}
            />
          </Form.Item>
          <Form.Item>
            {
              getFieldDecorator('fullName', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your full name',
                  },
                ],
              })(
                  <Input
                      size="large"
                      placeholder="Full Name"
                  />,
              )
            }
          </Form.Item>
          <Form.Item>
            {
              getFieldDecorator('userName', {
                rules: [
                  {
                    required: true,
                    message: 'Please input user name!',
                  },
                  {
                    min: 6,
                    message: 'Username should have minimum 6 letters',
                  },
                  {
                    pattern: '^[a-zA-Z0-9_]+$',
                    message: 'User name can not contain whitespace or special characters',
                  },
                  {
                    validator: this.validateExistingUser,
                  },
                ],
              })(
                  <Input
                      size="large"
                      placeholder="Username"
                  />,
              )
            }
          </Form.Item>
          <Form.Item>
            {
              getFieldDecorator('email', {
                rules: [
                  {
                    type: 'email',
                    message: 'Email is not valid',
                  },
                  {
                    required: true,
                    message: 'Please input your email id!',
                  },
                ],
              })(
                  <Input
                      size="large"
                      placeholder="Email"
                  />,
              )
            }
          </Form.Item>
          <Form.Item>
            {
              getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your Password!',
                  },
                  {
                    min: 8,
                    message: 'Password should contain minimum of 8 letters',
                  },
                  {
                    pattern: '[0-9]',
                    message: 'Password should contain at least 1 number',
                  },
                ],
              })(
                  <Input.Password
                      size="large"
                      prefix={<Icon
                          type="lock"
                          style={{color: 'rgba(0,0,0,.25)'}}
                      />}
                      placeholder="Password"
                  />,
              )
            }
          </Form.Item>
          <Form.Item>
            {
              getFieldDecorator('confirm', {
                rules: [
                  {
                    required: true,
                    message: 'Please confirm your password!',
                  },
                  {
                    validator: this.compareToFirstPassword,
                  },
                ],
              })(<Input.Password
                  size="large"
                  onBlur={this.handleConfirmBlur}
                  prefix={<Icon
                      type="lock"
                      style={{color: 'rgba(0,0,0,.25)'}}
                  />}
                  placeholder="Confirm Password"
              />)
            }
          </Form.Item>
          <Form.Item>
            <Button
                type="primary"
                shape={'round'}
                htmlType="submit"
                className="login-form-button"
                block
            >Join medCampus</Button>
          </Form.Item>
          {
            inPage === undefined && <p
                className="text-center"
                style={{cursor: 'pointer', color: '#1890ff'}}
                onClick={handleFormDisplay}
            >Sign In</p>
          }
        </Form>
    );
  }
}

const NavbarSignup = Form.create({name: 'navbar-signup'})(WrappedNavbarSignup);

export {NavbarSignup};
